// @flow

import React, { Component } from 'react';
import ReactMapboxGL from 'react-mapbox-gl';
import { connect } from 'react-redux';
import 'mapbox-gl/dist/mapbox-gl.css';
import type { LngLatBoundsLike } from 'mapbox-gl/src/geo/lng_lat_bounds';

import emptyStyle from './styles/empty-style';
import VenueStyle from './styles/venue';
import DisplayFeatures from './display-features';
import FlyToSelected from './fly-to-selected';
import Controls from './controls';
import SizeUpdater from './size-updater';
import {
  selectDebug,
  selectMaxBounds,
  selectFitBounds,
  selectTileJSON,
  selectMapClass,
  selectMapStyle,

  updateViewport,
} from './modules/map';

const MapboxGL = ReactMapboxGL({
  accessToken: '',
  trackResize: false,
  maxZoom: 8,
  attributionControl: false,
});

const fitBoundsOptions = {
  linear: true,
  animate: false,
};

type Props = {
  debug?: boolean,
  maxBounds: LngLatBoundsLike,
  fitBounds: LngLatBoundsLike,
  tileJSON: {},
  className?: string,
  style?: {},

  updateViewport: ({ zoom: number, bounds: {} }) => void,
};

class SeatcrawlerMap extends Component<Props> {
  updateViewport = map => this.props.updateViewport({
    zoom: map.getZoom(),
    bounds: map.getBounds().toArray(),
  });

  render() {
    if (!this.props.tileJSON) return null;

    return (
      <MapboxGL
        style={emptyStyle}
        className={this.props.className}
        containerStyle={this.props.style}
        maxBounds={this.props.maxBounds}
        fitBounds={this.props.fitBounds}
        fitBoundsOptions={fitBoundsOptions}
        onZoom={this.updateViewport}
        onStyleLoad={this.updateViewport}
      >
        {this.props.debug && <DisplayFeatures />}
        <SizeUpdater />
        <FlyToSelected />
        <Controls />
        <VenueStyle />
      </MapboxGL>
    );
  }
}

const mapStateToProps = state => ({
  debug: selectDebug(state),
  maxBounds: selectMaxBounds(state),
  fitBounds: selectFitBounds(state),
  tileJSON: selectTileJSON(state),
  className: selectMapClass(state),
  style: selectMapStyle(state),
});

const mapDispatchToProps = {
  updateViewport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SeatcrawlerMap);



// WEBPACK FOOTER //
// ./src/seatcrawler-map.js